var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow.companyImages
    ? _c(
        "div",
        { staticClass: "contents-inner", attrs: { "data-test": "images" } },
        [
          _c(
            "vue-slick-carousel",
            _vm._b(
              { staticClass: "main-slider image-height-auto" },
              "vue-slick-carousel",
              _vm.settings,
              false
            ),
            [
              _vm._l([1, 2, 3], function (index) {
                return [
                  _vm.companyInfo["companyImage" + index + "Caption"]
                    ? _c(
                        "div",
                        {
                          key: index,
                          staticClass: "item-slider image-height-auto",
                          attrs: { "data-test": "image-wrap-" + index },
                        },
                        [
                          _c(
                            "div",
                            {
                              style:
                                "background: url(" +
                                _vm.userCommonImageUrlForSp +
                                "/bg_stripe_gray.png) repeat top left;",
                              attrs: {
                                "data-test": "image-background-" + index,
                              },
                            },
                            [
                              _vm.companyInfo["companyImage" + index].id
                                ? _c("img", {
                                    staticClass: "max-w100",
                                    attrs: {
                                      src: _vm.getPhotoUrl(
                                        _vm.companyInfo["companyImage" + index]
                                      ),
                                      alt: _vm.companyInfo[
                                        "companyImage" + index + "Caption"
                                      ],
                                      "data-test": "image-" + index,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "slider-caption-parent" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "slider-caption",
                                      attrs: {
                                        "data-test": "caption-" + index,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.companyInfo[
                                              "companyImage" + index + "Caption"
                                            ]
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }